import React from "react";
import FieldInputMask from "../fieldInputMask";


const FieldInputCurp = ({colMd, colSm, label, name, onChange, onBlur, value, keyFilter, rows, disabled,formatType,error, errors,required}) => {


    return (
        <>

          {label   &&
           <FieldInputMask maskVariable="******************" name={name} label={label} colMd={colMd} required={required} errors={errors} disabled={disabled}
            value={ value }  onChange={onChange}/>
          }

           {!label  &&
            <FieldInputMask maskVariable="******************" name={name} colMd={colMd} errors={errors} disabled={disabled}
             value={ value }  onChange={onChange}/>            
            }
        </>
    )
};


export default FieldInputCurp;
